$(document).ready(function(){
//        code by RB
  //   footer newsletter form start  
  
  $('.footer__newsletter-input').keyup(function() {
    var txtVal = this.value;
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    if(!pattern.test(txtVal))
    {
      $('.footer__newsletter-btn').css('color','#ddd');
    }else{
      $('.footer__newsletter-btn').css('color','#4faf46');
    }
  });
  
  //   footer newsletter form end
  
  //   product MainImages Click initialize zoom start
  
  $(document).on('click', '.product-images-custom-zoom', function(){
    var zoom_selectimg = $(this).data('hideimg');
    $('.product-images-custom-zoom').attr('data-zoom-image',zoom_selectimg);
    $(this).addClass('startzoom');
    $('.startzoom').elevateZoom({
      zoomType: "inner",
      cursor: "crosshair",
      zoomWindowFadeIn: 500,
      zoomWindowFadeOut: 750
    });
  });
  
  //     product MainImages Click initialize zoom end
  
  //   product MainImages slide change zoom remove start
  
  $('#product-main-img-slider').on('afterChange', function(event, slick, currentSlide){
    console.log('change');
    $('.product-images-custom-zoom').removeClass('startzoom');
    //      $(slick.$slides[currentSlide]).find('.product-images-custom-zoom').removeClass('startzoom');
    $.removeData($('.startzoom'), 'elevateZoom');
    $('.zoomContainer').remove();
  });
  
  //   product MainImages slide change zoom remove end
  
  //click on variant product imgaes change start
  
  $(document).on('click', '.variant__button-label', function(){
    $('.variant__button-label').removeClass('selected-variant-class');
    $(this).addClass('selected-variant-class');
    var select_color = $(this).attr('data-varname');
    var select_size = $('.select-box-variant-size').val();
    if(select_size == null){
      var combination_variant = select_color
    }else{
       var combination_variant = select_color+' / '+select_size;
    }
   
    changeThumbImages(combination_variant);

  });
  
  $("select.select-box-variant-size").on('change',function(){
   var selectedsize = $(this).children("option:selected").val();

   var  select_color = $('.selected-variant-class').attr('data-varname');
    var select_size = selectedsize;
    if(select_size == null){
      var combination_variant = select_color;
    }else if(select_color == null){
      var combination_variant = select_size;
    }else{
       var combination_variant = select_color+' / '+select_size;
    }

    changeThumbImages(combination_variant);
   
 });
  
  function changeThumbImages(combination_variant){
  	$('.forvariant-alttag-imgs-url option').each(function(){
      var allvariant = $(this).text();
      var trimvariant = $.trim(allvariant);
      if(trimvariant == combination_variant){
        var selecturl = $(this).data('url');
        jQuery.ajax({
          type: 'GET',
          url: selecturl,
          dataType: 'html',
          success: function(data){
            
            //             html append
            $('.product-left-image').html($(data).find('.product-left-image').html());
            
            //             slide initialize
            
            
            
            
          },
          error: function(data){
            console.log('error');
          }
        });
      }
    });
  }
  //click on variant product imgaes change end
  
//   $('.cart__product-qty').change(function(){
//     var productid = $(this).data('id');
//     var quantity = $(this).val();
//     jQuery.ajax({  
//     type: 'POST',
//     url: '/cart/change.js',
//     data:{
//       id: productid,
//       quantity: quantity
//     },
//     dataType: 'json',
//     success: function(productid){
//       console.log('done');
//       getCartHtml();      
//     },
//   });
//   });


  
});
// cart page quantity box change ajax start
  function myfunction(item){
    console.log('change');
     var productid = $(item).data('id');
    var quantity = $(item).val();
    jQuery.ajax({  
    type: 'POST',
    url: '/cart/change.js',
    data:{
      id: productid,
      quantity: quantity
    },
    dataType: 'json',
    success: function(productid){
      console.log('done');
      getCartHtml();      
    },
  });
  }

  function getCartHtml(){
    jQuery.ajax({ 
      type: 'GET',
      url: '/cart',
      dataType: 'html',
      success: function(cart){      
        $('.cart-items-holder-main').html($(cart).find('.cart-items-holder-main').html());
        console.log('cart done');
      },
    });
  }
// cart page quantity box change ajax end

// change images on click size variant start (RB) sep 12
$(document).ready(function(){
 
  });
// change images on click size variant End





